import '../../css/FormTemplate.css'

const FormErrorDivTemplate = (props:{message:string, displayMessage:boolean }) => {

    return (
        <div className='form-template-input-error'>
            {props.displayMessage &&
                `${props.message}`
            }
        </div>
    );
};

export default FormErrorDivTemplate;